export default function ExpandableDirective() {
  return {
    template: require('./expandable.component.html'),
    transclude: true,
    restrict: 'E',
    scope: {
      required: '=',
      show: '=',
      onHide: '&',
      onShow: '&',
      title: '@'
    },
    bindToController: true,
    controllerAs: 'vm',
    controller: function () {
      var vm = this;
      init();

      function init() {
        if (vm.show !== true || vm.show !== false) {
          vm.show = true;
        }
      }

      vm.hideShow = function () {
        vm.show = !vm.show;
        if (!vm.show) {
          vm.onHide();
        } else if (vm.show) {
          vm.onShow();
        }
      };
    }
  };
}